const state = {
  models: {}
};
const getters = {
  getAssetModels: state => state.models
};
const actions = {
  setAssetModels({commit, state}, models) {
    state.models = models
    commit("setValueLoaded", "models")
  }
};

export default {
  state,
  getters,
  actions
};